import * as React from "react"
import Button from "./button"
import { StaticImage } from "gatsby-plugin-image"

export default function GetInvolvedBlock() {
  return (
    <div className="px-5 lg:p-0">
      <div className="get-involved-container mx-auto max-w-6xl my-10 lg:my-24 px-3">
        <div className="text-white flex flex-col md:flex-row items-center">
          <div className="w-full sm:w-[33.3%] flex justify-center pb-0 pt-12 md:pb-12">
            <StaticImage
              src="../images/bike-lane-icon.png"
              alt="Get Involved Icon"
              placeholder="blurred"
              width={238}
              height={307}
              className="mx-auto"
            />
          </div>
          <div className="hidden sm:block sm:w-[6.7%]"></div>
          <div className="w-full sm:w-[60%] pl-2 pr-4 md:px-12 py-12">
            <h2 className="font-dharma font-light text-7xl md:text-9xl leading-[0.9] mb-2 lg:mb-4">
              How you can make a difference
            </h2>
            <h3 className="font-montserrat font-light text-2xl md:3xl leading-8 mb-4 lg:mb-8">
              Make connections and help us transform America through bikes.
            </h3>
            <Button color="green" link={"/tools"} text="Get Involved" />
          </div>
        </div>
      </div>
    </div>
  )
}
